import { useContext } from 'react';
import { WindowContext } from 'contexts/WindowContext';

export function useWindow() {
    const { windowWidth, ...context } = useContext(WindowContext);
    const isMobile = windowWidth <= 630;
    return { windowWidth, isMobile, ...context };
}
